<template>
  <el-form
    :model="form"
    ref="form">
    <!-- SHIPPING -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('shipping')}}</h3>
      </div>
      <!-- content -->
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship')"
          prop="shipToCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.shipToCompanyID"
            @on-change="(id) => mixChangeShipToID(id)"
            @on-created="mixCreateShipTo"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship-detail')"
          prop="shipToCompanyDetailID"
          class="material-style">
          <select-company-detail
            :model.sync="form.shipToCompanyDetailID"
            :companyID="form.shipToCompanyID"
            @update:model="updateModelItem('shipToCompanyDetailID', { required: false })"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship-contact')"
          prop="shipToCompanyContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.shipToCompanyContactID"
            :companyID="form.shipToCompanyID"
            @update:model="updateModelItem('shipToCompanyContactID', { required: false })"
          ></select-company-contact>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('forwarder-ship-via')"
          prop="shipViaForwarderID"
          class="material-style"
        >
          <select-forwarder
            :model.sync="form.shipViaForwarderID"
            :companyID="form.shipToCompanyID"
            @update:model="updateModelItem('shipViaForwarderID', { required: false })"
          ></select-forwarder>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('shipping-porforma-number')"
          prop="shippingPorformaNumber"
          class="material-style"
        >
          <el-input
            :value="form.shippingPorformaNumber"
            @input="form.shippingPorformaNumber = valueTrimLeft($event)"
            @change="updateModelItem('shippingPorformaNumber', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('proforma-date')"
          prop="paymentChequeNo"
          class="material-style"
        >
          <date-picker
            v-model="form.paymentChequeNo"
            @change="updateModelItem('paymentChequeNo', { required: false })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('no-of-boxes')"
          prop="noOfBoxes"
          class="material-style"
        >
          <el-input
            :value="form.noOfBoxes"
            @input="form.noOfBoxes = valueNumber($event)"
            @change="updateModelItem('noOfBoxes', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('awb')"
          prop="awb"
          class="material-style"
        >
          <el-input
            :value="form.awb"
            @input="form.awb = valueTrimLeft($event)"
            @change="updateModelItem('awb', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateShipTo } from '@/mixins/companies'

export default {
  name: 'FormPO',
  mixins: [Form, mixUpdateShipTo],
  components: {
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue')
  },
  props: {
    dataID: { required: true }
  },
  computed: {
    mixRelatedShipToFields () {
      return [
        {
          fieldName: 'shipToCompanyContactID',
          createField: 'contactID'
        },
        {
          fieldName: 'shipToCompanyDetailID',
          createField: 'companyDetailID'
        },
        {
          fieldName: 'shipViaForwarderID'
        }
      ]
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `SalesOrders/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    }
  }
}
</script>
